import { apiCheckCompany, apiRegister } from '../../../../apis/registration'
import { env } from '../../../../constants'

export function isEmail(email) {
  return /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/.test(email)
}

/**
 * 向远端请求 company 可用性检测
 * @param {object} data 
 * @param {string} data.email
 * @param {string} [data.company]
 * @returns {Promise<{userCategory: string, existTenant: string, readyTenant: string}>}
 */
export function requestCheckCompany(data) {
  if (env.USE_MOCK) {
    return new Promise((resolve, reject) => {
      // reject(new Error('An error has occurred. Please refresh the page and try again.'))
      // return
      if (data.company) {
        resolve({
          userCategory: 'company',
          existTenant: data.company,
          readyTenant: ['splashtopteam', 'splashtopgroup', 'splashtop1'][Math.floor(Math.random() * 3)],
        })
      } else {
        resolve({
          userCategory: 'company',
          existTenant: 'splashtop',
          readyTenant: ['splashtopteam', 'splashtopgroup', 'splashtop1'][Math.floor(Math.random() * 3)],
        })
      }
    })
  }

  return apiCheckCompany.request(data)
    .then(response => {
      return {
        userCategory: response.email_category,
        existTenant: response.exist_tenant,
        readyTenant: response.ready_tenant,
      }
    })
}

export function abortCheckCompany() {
  apiCheckCompany.abort()
}

export function requestRegister(data) {
  if (env.USE_MOCK) {
    // mock
    console.log('register data:', data)
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        resolve({
          reg_token: 'reg_token',
          company: 'company',
        })
      }, 2000)
    })
  }

  return apiRegister.request({
    ...data,
  })
}
